import { HANDLE_AGENT_DETAILS, RESET } from '../actions';

const initialState = {};

const AgentDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_AGENT_DETAILS:
            return action.data;
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default AgentDetails;